import { ref, computed } from 'vue'

export function useOtpValidation() {
  const otp = ref<string>('')
  const otpError = ref<string | undefined>(undefined)

  const isValid = computed(() => otp.value.length === 4)

  const handleOtpInputUpdate = (value: string | number): void => {
    otp.value = String(value)
    if (otpError.value) {
      otpError.value = undefined
    }
  }

  const validateOtp = (): boolean => {
    if (!otp.value) {
      otpError.value = 'OTP is required'
      return false
    }
    if (otp.value.length !== 4) {
      otpError.value = 'OTP must be 4 digits'
      return false
    }
    otpError.value = undefined
    return true
  }

  const clearError = (): void => {
    otpError.value = undefined
  }

  const setError = (error: string): void => {
    otpError.value = error
  }

  return {
    otp,
    otpError,
    isValid,
    handleOtpInputUpdate,
    validateOtp,
    clearError,
    setError,
  }
}
